import {
    CHANNEL_AFTER_SALES_MANAGE,
    SUPPLIER_AFTER_SALES_MANAGE,
    SUPPLIER_DISTRIBUTOR_AFTER_SALES
} from '@/modules/order/constants'
import { message as $message } from 'antd'
import { isGXPlusOrder } from '@/modules/order/helper'
import { getTerminaDomain } from '@/utils/utils'
import { history } from 'umi'

const jumpAfterSalePath = soIdList => {
    let path = ''
    let terminalName = ''
    if (MASTER_IS_CHANNEL) {
        path = CHANNEL_AFTER_SALES_MANAGE
        terminalName = window.PROJECT_CONFIG.channelTerminalName
    }
    if (MASTER_IS_SUPPLIER) {
        terminalName = window.PROJECT_CONFIG.supplierTerminalName

        path = SUPPLIER_AFTER_SALES_MANAGE
    }

    jumpEnd(terminalName, `${path}?onLineOrderNo=${soIdList}&afterSaleStatus=WaitConfirm,Confirmed`)
}

const jumpDistributorAfterSale = soIdList => {
    let path = ''
    let terminalName = ''

    if (MASTER_IS_CHANNEL) {
        return $message.warning('请先切换供应商身份，再进行点击查看。')
    }
    if (MASTER_IS_SUPPLIER) {
        path = SUPPLIER_DISTRIBUTOR_AFTER_SALES
        terminalName = window.PROJECT_CONFIG.supplierTerminalName
    }

    jumpEnd(terminalName, `${path}?onLineOrderNo=${soIdList}&afterSaleStatus=WaitConfirm,Confirmed`)
}

const jumpEnd = (terminalName: string, path: string) => {
    const origin = getTerminaDomain(terminalName)

    const fullUrl = `${origin}${path}`

    window.open(fullUrl)
}

export const handelClickOlineSoidAfterSaleCountInOrder = ({ soIdList, orderType }) => {
    const isGXPlusOrderBool = isGXPlusOrder(orderType)

    if (isGXPlusOrderBool) {
        jumpDistributorAfterSale(soIdList)
    } else {
        jumpAfterSalePath(soIdList)
    }
}

type Type = 'afterSale' | 'distributorAfterSale'

export const handelClickOlineSoidAfterSaleCountInAfterSale = (soIdList: string, type: Type) => {
    let path = SUPPLIER_DISTRIBUTOR_AFTER_SALES
    if (type === 'afterSale') {
        path = SUPPLIER_AFTER_SALES_MANAGE
    }
    const keys = path.split('/')
    path = `/${keys[keys.length - 1]}`
    const url = `${path}?onLineOrderNo=${soIdList}&afterSaleStatus=WaitConfirm,Confirmed`
    history.replace(url)
}
